import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

// Instance axios pour les employés
const api = axios.create({
  baseURL: `${API_BASE_URL}/employees`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token à chaque requête
api.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs de réponse
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      
      // Erreur 401 - Non authentifié
      if (status === 401) {
        console.warn('Session expirée ou non authentifié');
        authService.logout();
        window.location.href = '/login';
        return Promise.reject(error);
      }
      
      // Erreur 403 - Accès refusé
      if (status === 403) {
        console.warn('Accès refusé - Permissions insuffisantes');
        // Ne pas rediriger automatiquement, laisser le composant gérer
      }
      
      // Erreur 500+ - Erreur serveur
      if (status >= 500) {
        console.error('Erreur serveur:', error.response.data);
      }
    }
    
    return Promise.reject(error);
  }
);

export const employeeService = {
  getAll: () => api.get(''),
  getById: (id) => api.get(`/${id}`),
  create: (employee) => api.post('', employee),
  update: (id, employee) => api.put(`/${id}`, employee),
  delete: (id) => api.delete(`/${id}`),
  search: (query) => api.get('/search', { params: { query } }),
  createUserAccess: (employeeId, payload) => api.post(`/${employeeId}/user`, payload),
  getDefaultBonuses: (employeeId) => api.get(`/${employeeId}/default-bonuses`),
  saveDefaultBonuses: (employeeId, bonuses) => api.put(`/${employeeId}/default-bonuses`, bonuses),
};

export default api;
